import { createSlice } from "@reduxjs/toolkit";
import {
  appointmentSummaryState,
  appointmentState,
  pastAppointmentState,
  appointmentCounter,
  practitionerSlots,
  createSlotState,
  updateSlotState,
  createUnavailable,
  unavailableRange,
  unavailableAppointment,
  editUnavailable,
  deleteUnavailable,
  appointmentDetail,
  deleteScheduleState,
  deletAllSlotState,
  deletAllUnavailableState,
  availableSlotState,
  createAppointmentState,
  followUpAppointmentState,
  followUpAppointmentCounterState,
} from "../../state/index";

const appointmentSummary = createSlice({
  name: "APPOINTMENT_SUMMARY_SLICE",
  initialState: appointmentSummaryState,
  reducers: {
    startAppointmentSummary: (state) => {
      state.loading = true;
      state.error = null;
    },
    successAppointmentSummary: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorAppointmentSummary: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const appointmentSlice = createSlice({
  name: "APPOINTMENT_SLICE",
  initialState: appointmentState,
  reducers: {
    startAppointment: (state) => {
      state.loading = true;
      state.error = null;
    },
    successAppointment: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorAppointment: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const pastAppointmentSlice = createSlice({
  name: "PAST_APPOINTMENT_SLICE",
  initialState: pastAppointmentState,
  reducers: {
    startPastAppointment: (state) => {
      state.loading = true;
      state.error = null;
    },
    successPastAppointment: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorPastAppointment: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const appointmentCounterSlice = createSlice({
  name: "APPOINTMENT_COUNTER_SLICE",
  initialState: appointmentCounter,
  reducers: {
    startAppointmentCounter: (state) => {
      state.loading = true;
      state.error = null;
    },
    successAppointmentCounter: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorAppointmentCounter: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const getSlotsSlice = createSlice({
  name: "GET_SLOTS_SLICE",
  initialState: practitionerSlots,
  reducers: {
    startSlot: (state) => {
      state.loading = true;
      state.error = null;
    },
    successSlot: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorSlot: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const createSlotsSlice = createSlice({
  name: "CREATE_SLOTS_SLICE",
  initialState: createSlotState,
  reducers: {
    startCreateSlot: (state) => {
      state.slotLoading = true;
      state.sloatError = null;
    },
    successCreateSlot: (state, action) => {
      state.slotLoading = false;
      state.slotData = action.payload.payload;
    },
    errorCreateSlot: (state, action) => {
      state.slotLoading = false;
      state.sloatError = action.payload;
    },
    resetCreateSlot: (state) => {
      state.slotLoading = false;
      state.slotData = null;
      state.sloatError = null;
    },
  },
});

const updateSlotsSlice = createSlice({
  name: "UPDATE_SLOTS_SLICE",
  initialState: updateSlotState,
  reducers: {
    startUpdateSlot: (state) => {
      state.updateSlotLoading = true;
      state.updateSlotError = null;
    },
    successUpdateSlot: (state, action) => {
      state.updateSlotLoading = false;
      state.updateSlotData = action.payload.payload;
    },
    errorUpdateSlot: (state, action) => {
      state.updateSlotLoading = false;
      state.updateSlotError = action.payload;
    },
    resetUpdateSlot: (state) => {
      state.updateSlotLoading = false;
      state.updateSlotData = null;
    },
  },
});

const createUnavialableSlice = createSlice({
  name: "CREATE_UNAVAIALABLE_SLICE",
  initialState: createUnavailable,
  reducers: {
    startUnavailable: (state) => {
      state.loading = true;
      state.error = null;
    },
    successUnavailable: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorUnavailable: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetUnavailable: (state) => {
      state.loading = false;
      state.data = null;
    },
  },
});

const getUnavailableRange = createSlice({
  name: "GET_UNAVAIALABLE_RANGE_SLICE",
  initialState: unavailableRange,
  reducers: {
    startRangeUnavailable: (state) => {
      state.rangeLoading = true;
      state.rangeError = null;
    },
    successRangeUnavailable: (state, action) => {
      state.rangeLoading = false;
      state.range = action.payload.payload;
    },
    errorRangeUnavailable: (state, action) => {
      state.rangeLoading = false;
      state.rangeError = action.payload;
    },
  },
});

const getUnavailableAppointment = createSlice({
  name: "GET_UNAVAIALABLE_APPOINTMENT_SLICE",
  initialState: unavailableAppointment,
  reducers: {
    startAppointmentUnavailable: (state) => {
      state.loading = true;
      state.error = null;
    },
    successAppointmentUnavailable: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorAppointmentUnavailable: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const editUnavialableSlice = createSlice({
  name: "EDIT_UNAVAIALABLE_SLICE",
  initialState: editUnavailable,
  reducers: {
    startEditUnavailable: (state) => {
      state.loading = true;
      state.errorEdit = null;
    },
    successEditUnavailable: (state, action) => {
      state.loading = false;
      state.editData = action.payload.payload;
    },
    errorEditUnavailable: (state, action) => {
      state.loading = false;
      state.errorEdit = action.payload;
    },
    resetEditUnavailable: (state) => {
      state.loading = false;
      state.editData = null;
    },
  },
});

const deleteUnavialableSlice = createSlice({
  name: "DELETE_UNAVAIALABLE_SLICE",
  initialState: deleteUnavailable,
  reducers: {
    startDeleteUnavailable: (state) => {
      state.loading = true;
      state.errorDelete = null;
    },
    successDeleteUnavailable: (state, action) => {
      state.loading = false;
      state.deleteData = action.payload.payload;
    },
    errorDeleteUnavailable: (state, action) => {
      state.loading = false;
      state.errorDelete = action.payload;
    },
    resetDeleteUnavailable: (state) => {
      state.loading = false;
      state.deleteData = null;
      state.errorDelete = null;
    },
  },
});

const getAppointmentDetailSlice = createSlice({
  name: "GET_APPOINTMENT_DETAIL_SLICE",
  initialState: appointmentDetail,
  reducers: {
    startAppointmentDetail: (state) => {
      state.detailLoading = true;
      state.detailError = null;
    },
    successAppointmentDetail: (state, action) => {
      state.detailLoading = false;

      state.detail = action.payload.payload;
    },
    errorAppointmentDetail: (state, action) => {
      state.detailLoading = false;
      state.detailError = action.payload;
    },
  },
});

const deleteScheduleSlice = createSlice({
  name: "DELETE_SCHEDULE_SLICE",
  initialState: deleteScheduleState,
  reducers: {
    startDeleteSchedule: (state) => {
      state.deleteScheduleLoading = true;
      state.deleteScheduleError = null;
    },
    successDeleteSchedule: (state, action) => {
      state.detailLoading = false;

      state.deleteScheduleData = action.payload.payload;
    },
    errorDeleteSchedule: (state, action) => {
      state.deleteScheduleLoading = false;
      state.deleteScheduleError = action.payload;
    },
    resetDeleteSchedule: (state, action) => {
      state.deleteScheduleLoading = false;
      state.deleteScheduleError = null;
      state.deleteScheduleData = null;
    },
  },
});

const deleteAllSlotsSlice = createSlice({
  name: "DELETE_ALL_SLOTS_SLICE",
  initialState: deletAllSlotState,
  reducers: {
    startDeleteAllSlot: (state) => {
      state.deleteAllLoading = true;
      state.deleteAllError = null;
    },
    successDeleteAllSlot: (state, action) => {
      state.deleteAllLoading = false;

      state.deleteAllData = action.payload.payload;
    },
    errorDeleteALlSlot: (state, action) => {
      state.deleteAllLoading = false;
      state.deleteAllError = action.payload;
    },
    resetDeleteAllSlot: (state, action) => {
      state.deleteAllLoading = false;
      state.deleteAllError = null;
      state.deleteAllData = null;
    },
  },
});

const deleteAllUnavailableSlice = createSlice({
  name: "DELETE_ALL_UNAVAILABLE_SLICE",
  initialState: deletAllUnavailableState,
  reducers: {
    startDeleteUnavailableSlot: (state) => {
      state.deleteAllUnLoading = true;
      state.deleteAllUnError = null;
    },
    successDeleteUnavailableSlot: (state, action) => {
      state.deleteAllUnLoading = false;

      state.deleteAllUnData = action.payload.payload;
    },
    errorDeleteUnavailableSlot: (state, action) => {
      state.deleteAllUnLoading = false;
      state.deleteAllUnError = action.payload;
    },
    resetDeleteUnavailableSlot: (state, action) => {
      state.deleteAllUnLoading = false;
      state.deleteAllUnError = null;
      state.deleteAllUnData = null;
    },
  },
});

export const {
  startDeleteUnavailableSlot,
  successDeleteUnavailableSlot,
  errorDeleteUnavailableSlot,
  resetDeleteUnavailableSlot,
} = deleteAllUnavailableSlice.actions;

export const {
  startDeleteAllSlot,
  successDeleteAllSlot,
  errorDeleteALlSlot,
  resetDeleteAllSlot,
} = deleteAllSlotsSlice.actions;

export const {
  startDeleteSchedule,
  successDeleteSchedule,
  errorDeleteSchedule,
  resetDeleteSchedule,
} = deleteScheduleSlice.actions;

export const {
  startAppointmentDetail,
  successAppointmentDetail,
  errorAppointmentDetail,
} = getAppointmentDetailSlice.actions;

export const {
  startDeleteUnavailable,
  successDeleteUnavailable,
  errorDeleteUnavailable,
  resetDeleteUnavailable,
} = deleteUnavialableSlice.actions;

export const {
  startAppointmentSummary,
  successAppointmentSummary,
  errorAppointmentSummary,
} = appointmentSummary.actions;

export const {
  startPastAppointment,
  successPastAppointment,
  errorPastAppointment,
} = pastAppointmentSlice.actions;

export const { startAppointment, successAppointment, errorAppointment } =
  appointmentSlice.actions;

export const {
  startAppointmentCounter,
  successAppointmentCounter,
  errorAppointmentCounter,
} = appointmentCounterSlice.actions;

export const { startSlot, successSlot, errorSlot } = getSlotsSlice.actions;

export const {
  startCreateSlot,
  successCreateSlot,
  errorCreateSlot,
  resetCreateSlot,
} = createSlotsSlice.actions;

export const {
  startUpdateSlot,
  successUpdateSlot,
  errorUpdateSlot,
  resetUpdateSlot,
} = updateSlotsSlice.actions;

export const {
  startUnavailable,
  successUnavailable,
  errorUnavailable,
  resetUnavailable,
} = createUnavialableSlice.actions;

export const {
  startRangeUnavailable,
  successRangeUnavailable,
  errorRangeUnavailable,
} = getUnavailableRange.actions;

export const {
  startAppointmentUnavailable,
  successAppointmentUnavailable,
  errorAppointmentUnavailable,
} = getUnavailableAppointment.actions;

export const {
  startEditUnavailable,
  successEditUnavailable,
  errorEditUnavailable,
  resetEditUnavailable,
} = editUnavialableSlice.actions;

const getAvailableSlotSlice = createSlice({
  name: "GET_AVAILABLE_SLOT_SLICE",
  initialState: availableSlotState,
  reducers: {
    startAvailableSlot: (state) => {
      state.loading = true;
      state.error = null;
    },
    successAvailableSlot: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorAvailableSlot: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  startAvailableSlot,
  successAvailableSlot,
  errorAvailableSlot,
} = getAvailableSlotSlice.actions;

const createAppointmentSlice = createSlice({
  name: "CREATE_APPOINTMENT_SLICE",
  initialState: createAppointmentState,
  reducers: {
    startCreateAppointment: (state) => {
      state.loading = true;
      state.error = null;
    },
    successCreateAppointment: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorCreateAppointment: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetCreateAppointment: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
});

export const {
  startCreateAppointment,
  successCreateAppointment,
  errorCreateAppointment,
  resetCreateAppointment,
} = createAppointmentSlice.actions;

const followUpAppointmentSlice = createSlice({
  name: "FOLLOW_UP_APPOINTMENT_SLICE",
  initialState: followUpAppointmentState,
  reducers: {
    startFollowUpAppointment: (state) => {
      state.loading = true;
      state.error = null;
    },
    successFollowUpAppointment: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorFollowUpAppointment: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

const followUpAppointmentCounterSlice = createSlice({
  name: "FOLLOW_UP_APPOINTMENT_COUNTER_SLICE",
  initialState: followUpAppointmentCounterState,
  reducers: {
    startFollowUpAppointmentCounter: (state) => {
      state.loading = true;
      state.error = null;
    },
    successFollowUpAppointmentCounter: (state, action) => {
      state.loading = false;
      state.data = action.payload.payload;
    },
    errorFollowUpAppointmentCounter: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  startFollowUpAppointment,
  successFollowUpAppointment,
  errorFollowUpAppointment,
} = followUpAppointmentSlice.actions;

export const {
  startFollowUpAppointmentCounter,
  successFollowUpAppointmentCounter,
  errorFollowUpAppointmentCounter,
} = followUpAppointmentCounterSlice.actions;

export const getAppointmentSummaryReducer = appointmentSummary.reducer;
export const getAppointmentReducer = appointmentSlice.reducer;
export const getPastAppointmentReducer = pastAppointmentSlice.reducer;
export const getAppointmentCounterReducer = appointmentCounterSlice.reducer;
export const getSlotsReducer = getSlotsSlice.reducer;
export const createSlotsReducer = createSlotsSlice.reducer;
export const updateSlotsReducer = updateSlotsSlice.reducer;
export const createUnavialableReducer = createUnavialableSlice.reducer;
export const getUnavialableReducer = getUnavailableRange.reducer;
export const getUnavialableAppointmentReducer =
  getUnavailableAppointment.reducer;
export const editUnailableReducer = editUnavialableSlice.reducer;
export const deleteUnavailableReducer = deleteUnavialableSlice.reducer;
export const getAppointmentDetailReducer = getAppointmentDetailSlice.reducer;
export const deleteScheduleReducer = deleteScheduleSlice.reducer;
export const deleteAllScheduleReducer = deleteAllSlotsSlice.reducer;
export const deleteAllUnavailableReducer = deleteAllUnavailableSlice.reducer;
export const getAvailableSlotReducer = getAvailableSlotSlice.reducer;
export const createAppointmentReducer = createAppointmentSlice.reducer;
export const getFollowUpAppointmentReducer = followUpAppointmentSlice.reducer;
export const getFollowUpAppointmentCounterReducer = followUpAppointmentCounterSlice.reducer;
